// ============= GA4 ANALYTICS (Measurement ID in public/index.html) =============
// Thin wrapper around window.gtag. Safe to call before gtag is loaded (noop)
// and from any environment (preview, prod). gtag itself only ships to the
// production hostname — see the inline bootstrap in public/index.html — so
// these calls are a no-op on preview / localhost unless `?ga=1` is set.

const DEBUG = typeof window !== "undefined" && new URLSearchParams(window.location.search).get("ga") === "debug";

export function trackEvent(name, params = {}) {
  if (typeof window === "undefined") return;
  if (DEBUG) console.log("[ga4]", name, params);
  const g = window.gtag;
  if (typeof g !== "function") return;
  try { g("event", name, params); } catch (_e) { /* noop */ }
}

export function trackPageView(path) {
  if (typeof window === "undefined") return;
  const g = window.gtag;
  if (typeof g !== "function") return;
  try {
    // Use the measurement ID baked into the gtag config in index.html —
    // we rely on gtag's default page_location/page_path from history
    // changes but also fire an explicit page_view for SPA transitions.
    g("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  } catch (_e) { /* noop */ }
}
